var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6238",
    fill: "none",
    d: "M0 0h20v20H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11359",
    fill: "none",
    stroke: "#006e94",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26736",
    d: "M10.192 11.729h0a2.021 2.021 0 01-2.015-2.014v-5.7a2.015 2.015 0 014.03 0v5.7a2.021 2.021 0 01-2.015 2.014z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26737",
    d: "M15.319 9.813A5.16 5.16 0 015 9.813"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1039",
    d: "M10.159 14.972v3.112"
  }))));
}
export default SvgIcVoice;